if (!customElements.get("filter-tabs")) {
  customElements.define(
    "filter-tabs",
    class FilterTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.updateSort();

        this.close_btn = this.querySelector(".filter_modal_close_btn");
        if (this.close_btn) {
          this.close_btn.addEventListener("click", this.closeFilterMobile.bind(this));
        }

        this.open_btn = document.querySelector(".open_filter_tab_mobile");
        if (this.open_btn) {
          this.open_btn.addEventListener("click", this.openFilterMobile.bind(this));
        }

        this.overlay = document.querySelector(".filter_layout_side .filter_modal_overlay");
        this.overlay.addEventListener("click", this.closeFilterMobile.bind(this));

        this.collectionPaginate = document.querySelector("collection-paginate");
        this.all_tags = JSON.parse(this.querySelector("#collectionTags").innerHTML);
        const sizeFilterValues = this.querySelector("#collectionSizeFilterValues");
        try {
          this.variant_size_values = sizeFilterValues
            ? JSON.parse(sizeFilterValues.textContent || "[]")
            : [];
        } catch (error) {
          console.error("Failed to parse collection Size filter values", error);
          this.variant_size_values = [];
        }
        this.hidden_size_values = new Set(
          String(this.dataset.hiddenSizeValues || "")
            .split(",")
            .map((value) => this.normalizeSizeKey(value))
            .filter(Boolean)
        );
        this.filterListContainer = this.querySelector(".filter-list__container");
        this.renderFilterContainer();

        this.controlBtns = this.querySelectorAll(".control-btn");
        this.controlBtns.forEach((btn) => {
          btn.addEventListener("click", this.controlBtnClick.bind(this));
        });

        this.sortBtns = this.querySelectorAll("[data-list-type='sorting'] .sortBtn");
        this.sortBtns.forEach((sortbtn) => {
          sortbtn.addEventListener("click", this.sortBtnClick.bind(this));
          sortbtn.addEventListener("keyup", this.sortBtnKeyUp.bind(this));
        });
      }

      renderFilterContainer() {
        const sizes = [],
          colors = [],
          categories = [],
          prices = [];

        const colorRegex = "^colorfamily";
        const sizeRegex = "^size_[0-9]";
        const categoryRegex = "^category";
        const priceRegex = "^price";

        this.all_tags
          .filter((tag) => {
            if (
              tag.match(colorRegex) ||
              tag.match(sizeRegex) ||
              tag.match(categoryRegex) ||
              tag.match(priceRegex)
            )
              return tag;
          })
          .forEach((tag) => {
            if (tag.match(colorRegex)) {
              const processedTag = tag.replace("colorfamily", "color");
              const tagData = processedTag.split("_");
              colors.push({
                tag: processedTag,
                value: tagData[1].toLowerCase(),
              });
            } else if (tag.match(sizeRegex)) {
              const tagData = tag.replace("-", ".").split("_");
              // console.log(tagData);
              sizes.push({
                tag: tag,
                value: tagData[1].toLowerCase(),
                type:
                  tagData[1] === "0.3" ||
                    tagData[1] === "3.6" ||
                    tagData[1] === "6.9" ||
                    tagData[1] === "9.12"
                    ? "baby"
                    : tagData[2] || "adult",
              });
            } else if (tag.match(categoryRegex)) {
              const tagData = tag.split("_");
              categories.push({
                tag: tag.replaceAll(" ", ""),
                value: tagData[1].toLowerCase(),
              });
            } else if (tag.match(priceRegex)) {
              const tagData = tag.split("_");
              prices.push({
                tag: tag.replaceAll(" ", ""),
                value: tagData[1].toLowerCase(),
              });
            }
          });

        this.mergeVariantSizes(sizes);
        const visibleSizes = sizes.filter(
          (size) => !this.hidden_size_values.has(this.normalizeSizeKey(size.value))
        );

        const newHTML = `
          <div class="filter-list__categories">
            ${this.renderSizes(visibleSizes)}
            ${this.renderColumn("category", categories)}
            ${this.renderColumn("price", prices)}
            ${this.renderColors(colors)}
          </div>
        `;
        this.filterListContainer.innerHTML = newHTML;
      }

      normalizeSizeKey(rawValue) {
        return String(rawValue || "")
          .trim()
          .replace(/\s+/g, "")
          .toLowerCase();
      }

      variantSizeToLegacyTag(rawValue) {
        const normalized = String(rawValue || "")
          .trim()
          .replace(/\s+/g, "");
        const match = normalized.match(/^(\d+(?:\.\d+)?)(w)?$/i);
        if (!match) return null;

        const suffix = match[2] ? "W" : "";
        const displayValue = `${match[1]}${suffix}`;
        return {
          tag: `size_${match[1].replace(".", "-")}${suffix}`,
          value: displayValue.toLowerCase(),
          type: "adult",
        };
      }

      mergeVariantSizes(sizes) {
        const knownTags = new Set(
          sizes.map((size) => String(size.tag).toLowerCase())
        );
        const knownValues = new Set(
          sizes.map((size) => String(size.value).toLowerCase())
        );

        (Array.isArray(this.variant_size_values)
          ? this.variant_size_values
          : []
        ).forEach((filterValue) => {
          const size = this.variantSizeToLegacyTag(
            filterValue.value || filterValue.label
          );
          if (!size) return;

          const tagKey = size.tag.toLowerCase();
          const valueKey = size.value.toLowerCase();
          if (knownTags.has(tagKey) || knownValues.has(valueKey)) return;

          sizes.push(size);
          knownTags.add(tagKey);
          knownValues.add(valueKey);
        });
      }

      renderSizes(sizes) {
        const collectionHandle = this.getAttribute("collection-handle");
        let newSizes = [];

        if (
          collectionHandle === "baby" ||
          collectionHandle === "toddlers" ||
          collectionHandle === "girls" ||
          collectionHandle === "mommy-me" ||
          collectionHandle === "shop-all" ||
          collectionHandle === "spring-markdowns" ||
          collectionHandle === "kids" ||
          collectionHandle === "kids-jacks"
        ) {
          newSizes = sizes
            .sort((a, b) => a.value - b.value)
            .sort((a, b) => (a.type > b.type ? -1 : 1));
        } else {
          newSizes = sizes
            .map((size) => ({ ...size, numVal: parseFloat(size.value) }))
            .filter((size) => size.numVal >= 5)
            .sort((a, b) => a.numVal - b.numVal);
        }

        const isSideFilter = document.querySelector(".filter_layout_side");
        let sizesInnerHTML;

        const btn = (size, extraLabel = "") => {
          const isActive = this.collectionPaginate.activetags.includes(size.tag);
          const label =
            size.type === "baby"
              ? `${size.value.replace(".", "-")}${extraLabel}`
              : `${String(size.value).replace(/w$/i, "W")}${extraLabel}`;
          return `
            <filter-button
              tabindex="0"
              role="checkbox"
              aria-checked="${isActive ? "true" : "false"}"
              class="category-value size-filter-plp ${isActive ? "filter-active" : ""}"
              data-value="${size.tag}"
            >${label}</filter-button>
          `;
        };

        if (isSideFilter) {
          const sortNumeric = (arr) => arr.slice().sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
          const kidsSizes = sortNumeric(sizes.filter((s) => s.type === "kid"));
          const babySizes = sizes
            .filter((s) => s.type === "baby" && s.tag.includes("_baby"))
            .slice()
            .sort((a, b) => parseFloat(String(a.value).split(".")[0]) - parseFloat(String(b.value).split(".")[0]));
          const adultSizes = sizes.filter((s) => s.type === "adult" && parseInt(s.value) >= 5);

          const groupBlock = (title, list, labelSuffix = "") =>
            list.length
              ? `
                  <fieldset class="checkbox-group">
                    <legend>${title}</legend>
                    <ul class="category-values">
                      ${list.map((s) => `<li>${btn(s, labelSuffix)}</li>`).join("")}
                    </ul>
                  </fieldset>
                `
              : "";

          const groupsForKidsFirst =
            collectionHandle === "baby" ||
            collectionHandle === "toddlers" ||
            collectionHandle === "girls" ||
            collectionHandle === "kids" ||
            collectionHandle === "kids-jacks";

          const isWide = (s) => /w$/i.test(s.value);
          const numericVal = (s) => parseFloat(String(s.value).replace(/w$/i, ""));
          const isUK = (s) => {
            const n = numericVal(s);
            return Number.isFinite(n) && n >= 35 && n <= 45 && !isWide(s);
          };
          const adultRegularSizes = adultSizes.filter(
            (s) => !isWide(s) && !isUK(s)
          );
          const adultWideSizes = adultSizes.filter((s) => isWide(s));
          const adultUKSizes = adultSizes.filter((s) => isUK(s));

          const sortByNumeric = (arr) => arr.slice().sort((a, b) => numericVal(a) - numericVal(b));
          const regularBlock = groupBlock("Regular", sortByNumeric(adultRegularSizes));
          const wideBlock = groupBlock("Wide", sortByNumeric(adultWideSizes));
          const ukBlock = groupBlock("UK", sortByNumeric(adultUKSizes));
          const kidsBlock = groupBlock("Kids Sizes", kidsSizes, "");
          const babyBlock = groupBlock("Baby Sizes", babySizes, "");

          sizesInnerHTML =
            groupsForKidsFirst
              ? [kidsBlock, babyBlock, regularBlock, wideBlock, ukBlock].join("")
              : [regularBlock, wideBlock, ukBlock, kidsBlock, babyBlock].join("");
        } else {
          sizesInnerHTML = `
            <ul class="category-values">
              ${newSizes
              .map((size) => {
                const suffix =
                  size.type === "kid" ? " (kids)" :
                    size.type === "baby" ? " (baby)" : "";
                return `<li>${btn(size, suffix)}</li>`;
              })
              .join("")}
            </ul>
          `;
        }

        const sizesHTML = `
          <div class="filter-category" data-category="size">
            <filter-collapsible title="Sizes">
              ${sizesInnerHTML}
            </filter-collapsible>
          </div>
        `;
        return sizesHTML;
      }

      renderColors(colors) {
        const newHTML = `
        <div class="filter-category" data-category="color">
          <p class="category-title">color</p>
          <ul class="category-values">
            ${colors
            .map((color) => {
              return `
                <li>
                  <filter-button tabindex="0" role="checkbox" aria-checked="${this.collectionPaginate.activetags.includes(color.tag) ? "true" : "false"
                }" class="category-value ${this.collectionPaginate.activetags.includes(color.tag) ? "filter-active" : ""
                }"
                                  data-value="${color.tag}">
                    <span class="product-form__value--color ${color.value}"></span>
                    <span class="product-form__value--label">${color.value}</span>
                  </filter-button>
                </li>
              `;
            })
            .join("")}
          </ul>
        </div>
      `;

        return newHTML;
      }

      renderColumn(category, tags) {
        if (category === "price") {
          const priceRegex = "[$][0-9]+";
          const priceNumRegex = "[0-9]+";
          tags = tags
            .filter((tag) => {
              if (tag.value.match(priceRegex)) return tag;
            })
            .map((tag) => {
              const floatVal = tag.value.match(priceNumRegex)[0];
              return {
                ...tag,
                numVal: parseFloat(floatVal),
                labelOuter: "circle",
              };
            })
            .sort((a, b) => b.numVal - a.numVal);
        }

        function match(a, b) {
          return a.value == "sandals" ? -1 : 1;
        }

        tags = tags.sort(match);

        const newHTML = `
        <div class="filter-category" data-category="${category}">
          <p class="category-title">${category}</p>
          <ul class="category-values">
            ${tags
            .map((tag) => {
              return `
                <li>
                  <filter-button tabindex="0" role="checkbox" aria-checked="${this.collectionPaginate.activetags.includes(tag.tag) ? "true" : "false"
                }" class="category-value ${this.collectionPaginate.activetags.includes(tag.tag) ? "filter-active" : ""
                }"
                            data-value="${tag.tag}">${tag.value}</filter-button>
                  <div class="label ${tag.labelOuter == "circle" ? "circle" : "rect"}">
                    ${tag.labelOuter == "circle"
                  ? '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="6" fill="#F966F6" /></svg>'
                  : '<svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.7174 9.78858C6.13161 10.3744 5.18186 10.3744 4.59608 9.78858C4.01029 9.2028 4.01029 8.25305 4.59608 7.66726L11.6671 0.596195C12.2529 0.0104079 13.2027 0.0104073 13.7885 0.596194C14.3743 1.18198 14.3743 2.13173 13.7885 2.71751L6.7174 9.78858Z" fill="#F966F6"/><path d="M6.7174 7.66726C7.30318 8.25305 7.30319 9.2028 6.7174 9.78858C6.13161 10.3744 5.18186 10.3744 4.59608 9.78858L1.06054 6.25305C0.474758 5.66726 0.474757 4.71752 1.06054 4.13173C1.64633 3.54594 2.59608 3.54594 3.18186 4.13173L6.7174 7.66726Z" fill="#F966F6"/></svg>'
                }
                  </div>
                </li>
              `;
            })
            .join("")}
          </ul>
        </div>
      `;
        return newHTML;
      }

      controlBtnClick(event) {
        const activeBtn = this.querySelector(".control-btn.active");
        const controlBtn = event.target;
        const dataType = controlBtn.dataset.btnType;

        const activeContainer = this.querySelector(".filter-list__container.open");
        const listContainer = this.querySelector(
          `.filter-list__container[data-list-type="${dataType}"]`
        );
        const listContainerRect = listContainer.getBoundingClientRect();

        // deactive previous active elements (only if previous element is different than the current one)
        if (activeBtn && activeBtn !== controlBtn) {
          activeBtn.classList.remove("active");
          activeContainer.classList.remove("open");
        }

        controlBtn.classList.toggle("active");
        listContainer.classList.toggle("open");

        // update the margin status, depending on the active element
        if (controlBtn.classList.contains("active")) {
          this.style.marginBottom = `${listContainerRect.height + 40}px`;
        } else {
          this.style.marginBottom = `0px`;
        }
      }

      updateSort() {
        const searchParams = new URLSearchParams(window.location.search);
        const currentSortby = searchParams.get("sort_by") ? searchParams.get("sort_by") : "";

        const sortByToActivate = this.querySelector(`[data-sort="${currentSortby}"]`);
        sortByToActivate.classList.add("active");
      }

      sortBtnClick(event) {
        const sortbtn = event.target;
        const datasort = sortbtn.dataset.sort;

        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("sort_by", datasort);
        window.location.href = datasort
          ? `${window.location.pathname}?${searchParams.toString()}`
          : `${window.location.pathname}`;
      }

      sortBtnKeyUp(event) {
        if (event.code.toUpperCase() === "SPACE") {
          this.sortBtnClick(event);
        }
      }

      foldActiveContainer() {
        const activeBtn = this.querySelector(".control-btn.active");
        const activeContainer = this.querySelector(".filter-list__container.open");

        if (activeBtn) activeBtn.classList.remove("active");
        if (activeContainer) activeContainer.classList.remove("open");
        this.style.marginBottom = `0px`;
      }

      closeFilterMobile() {
        this.classList.add("close");
        document.body.classList.remove("overflow-hidden");
        this.overlay.classList.remove("active");
      }

      openFilterMobile() {
        this.classList.remove("close");
        document.body.classList.add("overflow-hidden");
        this.overlay.classList.add("active");
      }
    }
  );
}

if (!customElements.get("filter-button")) {
  customElements.define(
    "filter-button",
    class FilterButton extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.collectionPaginate = document.querySelector("collection-paginate");

        this.addEventListener("click", this.addFilter.bind(this));
        this.addEventListener("keyup", this.onKeyUpAddFilter.bind(this));
      }

      onKeyUpAddFilter(event) {
        if (event.code.toUpperCase() === "SPACE") {
          this.addFilter();
        }
      }

      addFilter() {
        const filterValue = this.dataset.value || "";
        const tags = filterValue.split(",").map((t) => t.trim()).filter(Boolean);

        const nowActive = !this.classList.contains("filter-active");
        this.classList.toggle("filter-active", nowActive);
        this.setAttribute("aria-checked", nowActive ? "true" : "false");

        if (nowActive) {
          tags.forEach((tag) => {
            if (!this.collectionPaginate.activetags.includes(tag)) {
              this.collectionPaginate.activetags.push(tag);
            }
          });
        } else {
          this.collectionPaginate.activetags = this.collectionPaginate.activetags.filter(
            (tag) => !tags.includes(tag)
          );
        }

        this.collectionPaginate.fetchFilterProdList();

        const filterTab = this.closest("filter-tabs");
        if (filterTab && typeof filterTab.foldActiveContainer === "function") {
          filterTab.foldActiveContainer();
        }
      }
    }
  );
}

if (!customElements.get("filter-selector-wrapper")) {
  customElements.define(
    "filter-selector-wrapper",
    class FilterSelectorWrapper extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.collectionPaginate = document.querySelector("collection-paginate");
        this.select = this.querySelector("select");
        this.currentValue = "";
        this.select.addEventListener("change", this.addFilter.bind(this));
      }

      addFilter(e) {
        if (this.collectionPaginate.activetags.indexOf(e.target.value) > -1) {
          return;
        }

        if (e.target.value != this.currentValue) {
          this.collectionPaginate.activetags.push(e.target.value);
          this.collectionPaginate.fetchFilterProdList();
          this.currentValue = e.target.value;
        }
      }
    }
  );
}

if (!customElements.get("filter-collapsible")) {
  customElements.define(
    "filter-collapsible",
    class FilterCollapsible extends HTMLElement {
      constructor() {
        super();
        this._isOpen = false;
      }

      connectedCallback() {
        const title = this.getAttribute("title") || "Toggle";
        const content = this.innerHTML;

        this.innerHTML = `
          <style>
            .filter-collapsible { width: 100%; }
            .collapsible-trigger {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 8px;
              background: transparent;
              border: 0;
              padding: 10px 0;
              cursor: pointer;
            }
            .collapsible-trigger__label { font-weight: 600; }
            .collapsible-trigger__icon {
              transition: transform 200ms ease;
              transform-origin: 50% 50%;
            }
            .is-open .collapsible-trigger__icon {
              transform: rotate(180deg);
            }

            /* painel animado por height (sem display:none/hidden) */
            .collapsible-panel {
              height: 0;
              overflow: hidden;
              transition: height 250ms ease;
              will-change: height;
            }
          </style>

          <div class="filter-collapsible" aria-live="polite">
            <button type="button"
                    class="collapsible-trigger"
                    aria-expanded="false"
                    aria-controls="panel-${this._uid()}"
                    id="trigger-${this._uid()}"
                    title="${title}">
              <span class="collapsible-trigger__label category-title" style="font-weight: 700;">${title}</span>
              <svg class="collapsible-trigger__icon" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M8.13171 8.08143C7.54592 8.66722 6.59617 8.66722 6.01038 8.08143C5.4246 7.49564 5.4246 6.5459 6.01038 5.96011L10.9601 1.01036C11.5459 0.424575 12.4957 0.424574 13.0815 1.01036C13.6672 1.59615 13.6672 2.54589 13.0815 3.13168L8.13171 8.08143Z" fill="#4F4F4F"/>
                <path d="M8.1317 5.96011C8.71749 6.54589 8.71749 7.49564 8.13171 8.08143C7.54592 8.66722 6.59617 8.66722 6.01038 8.08143L1.06064 3.13168C0.474851 2.5459 0.47485 1.59615 1.06064 1.01036C1.64642 0.424576 2.59617 0.424576 3.18196 1.01036L8.1317 5.96011Z" fill="#4F4F4F"/>
              </svg>
            </button>

            <div class="collapsible-panel"
                 id="panel-${this._uid()}"
                 role="region"
                 aria-labelledby="trigger-${this._uid()}">
              ${content}
            </div>
          </div>
        `;

        this.wrapper = this.querySelector(".filter-collapsible");
        this.trigger = this.querySelector(".collapsible-trigger");
        this.panel = this.querySelector(".collapsible-panel");

        // bind
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onTriggerKeyup = this.onTriggerKeyup.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);

        // listeners
        this.trigger.addEventListener("click", this.onTriggerClick);
        this.trigger.addEventListener("keyup", this.onTriggerKeyup);
        this.panel.addEventListener("transitionend", this.onTransitionEnd);

        this.open();
      }

      onTriggerClick() {
        if (this._isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      onTriggerKeyup(e) {
        if (e.code && e.code.toUpperCase() === "SPACE") {
          e.preventDefault();
          this.onTriggerClick();
        }
      }

      open() {
        this._isOpen = true;
        this.trigger.setAttribute("aria-expanded", "true");
        this.wrapper.classList.add("is-open");

        const startH = this.panel.offsetHeight;
        this.panel.style.height = startH + "px";
        this.panel.offsetHeight;
        const target = this.panel.scrollHeight;
        this.panel.style.height = target + "px";
      }

      close() {
        this._isOpen = false;
        this.trigger.setAttribute("aria-expanded", "false");
        this.wrapper.classList.remove("is-open");

        const current = this.panel.scrollHeight;
        this.panel.style.height = current + "px";
        this.panel.offsetHeight;
        this.panel.style.height = "0px";
      }

      onTransitionEnd(e) {
        if (e.propertyName !== "height") return;
        if (this._isOpen) {
          this.panel.style.height = "auto";
        }
      }

      _uid() {
        if (!this.__uid) {
          this.__uid = Math.random().toString(36).slice(2, 9);
        }
        return this.__uid;
      }
    }
  );
}
